import Vue from 'vue';
import store from './vueStore/store';
import router from './vueRouter/router';

//helpers
import { toggleClass } from './helpers/helpers'; //toggleClass('active', $event)
import { animateCSS } from './helpers/helpers'; //animateCSS(animationName, $event, [callback])

//global vue plugins
import './vuePlugins/VueAxios'; //this.axios
import './vuePlugins/checkView'; //v-view="$event => animateCSS('animationName', $event)"
import './vuePlugins/VueHead';
import './vuePlugins/vueCookies';
import './vuePlugins/lazyload';
import './vuePlugins/VueScrollTo';

//global vue components

//global vue sections

// --------------------
//       VUE.JS
// --------------------

//global mixin
Vue.mixin({
  data() {
    return {
      goToOptions: {
        offset: 170,
        infoBar: false
      }
    };
  },
  components: {},
  watch: {},
  methods: {
    toggleClass,
    animateCSS
  }
});

const App = new Vue({
  delimiters: ['%%', '%%'],
  store,
  router,
  data: {
    changeHeaderClass: false,
    statsOnScreen: false,
    windowWidth: window.innerWidth
  }, 
  components: {
    SectionCategory: () => import('./vueComponents/SectionCategory'),
    SectionProducts: () => import('./vueComponents/SectionProducts'),
    SectionFooter: () => import('./vueComponents/SectionFooter'),
    SectionNewsletter: () => import('./vueComponents/SectionNewsletter'),
    SectionProductsSlider: () => import('./vueComponents/SectionProductsSlider'),
    SectionTextImg: () => import('./vueComponents/SectionTextImg'),
    SectionFaq: () => import('./vueComponents/SectionFaq'),
    SectionInspirations: () => import('./vueComponents/SectionInspirations'),
  },  
  methods: {
    onLoadScrollToHash() {
      if (this.$route.hash) {
        window.onload = () => this.$scrollTo(this.$route.hash);
      }
    },
    changeHeader(e) {
      if (e.scrollPercent > 0) {
        this.changeHeaderClass = true;
      } else {
        this.changeHeaderClass = false;
      }
    },
    setStatsOnScreen(e) {
      if (e.type === 'enter') {
        this.statsOnScreen = true;
      }
    },
    isMobile(scr) {
      if (screen.width <= scr) {
          return true;
      } else {
          return false;
      }
    },
  },
  mounted() {
    this.onLoadScrollToHash();
    this.isMobile();
    // window.addEventListener('resize', () => {
    //   this.isMobile();
    // })
  }
});

if (document.querySelector('#app')) {
  App.$mount('#app');
} else {
  console.log('Vue error: "#app"" not found');
}
